import '../../../../vendor/moment/moment.js';
import '../../../../vendor/angular-moment/angular-moment.js';

export const moment = window.moment;
// configure relative times, which are dumb by default
// now we'll always expect a full unit of time before reducing precision
moment.relativeTimeThreshold('s', 59);
moment.relativeTimeThreshold('m', 59);
moment.relativeTimeThreshold('h', 24);
moment.relativeTimeThreshold('d', 30);
moment.relativeTimeThreshold('M', 12);

export const momentModule = 'angularMoment';
